import { CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';
import { TertiaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';

type NavIDs = {
  mobileTertiaryNavId: TertiaryNavIdentifier | '';
  tertiaryNavId: TertiaryNavIdentifier | '';
};

export const NAV_IDS_BY_CARD_TYPE: Record<string, NavIDs> = {
  [CARD_TYPE_MAP.std]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.SAVE_THE_DATE,
    tertiaryNavId: TertiaryNavIdentifier.SAVE_THE_DATE,
  },
  [CARD_TYPE_MAP.invitation]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.INVITATIONS,
    tertiaryNavId: TertiaryNavIdentifier.INVITATIONS,
  },
  [CARD_TYPE_MAP.details]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.ENCLOSURE,
    tertiaryNavId: TertiaryNavIdentifier.INVITATIONS,
  },
  [CARD_TYPE_MAP.menu]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.MENU,
    tertiaryNavId: TertiaryNavIdentifier.DAY_OF,
  },
  [CARD_TYPE_MAP.program]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.PROGRAM,
    tertiaryNavId: TertiaryNavIdentifier.DAY_OF,
  },
  [CARD_TYPE_MAP.place]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.PLACE,
    tertiaryNavId: TertiaryNavIdentifier.DAY_OF,
  },
  [CARD_TYPE_MAP.dstd]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.DIGITAL_SAVE_THE_DATE,
    tertiaryNavId: TertiaryNavIdentifier.DIGITAL_SAVE_THE_DATE,
  },
  [CARD_TYPE_MAP.thankyou]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.THANK_YOUS,
    tertiaryNavId: TertiaryNavIdentifier.THANK_YOUS,
  },
  [CARD_TYPE_MAP.holiday]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.HOLIDAY,
    tertiaryNavId: TertiaryNavIdentifier.HOLIDAY,
  },
  [CARD_TYPE_MAP.ctd]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.CHANGE_THE_DATE,
    tertiaryNavId: TertiaryNavIdentifier.SAVE_THE_DATE,
  },
  [CARD_TYPE_MAP.weddingShower]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.WEDDING_SHOWER_INVITATION,
    tertiaryNavId: TertiaryNavIdentifier.INVITATIONS,
  },
  [CARD_TYPE_MAP.tableNumber]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.DAY_OF,
    tertiaryNavId: TertiaryNavIdentifier.DAY_OF,
  },
  [CARD_TYPE_MAP.matchingSuites]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.COLLECTIONS_PAPER,
    tertiaryNavId: TertiaryNavIdentifier.COLLECTIONS_PAPER,
  },
  [CARD_TYPE_MAP.paperAddOns]: {
    mobileTertiaryNavId: TertiaryNavIdentifier.PAPER_ADD_ONS,
    tertiaryNavId: TertiaryNavIdentifier.PAPER_ADD_ONS,
  },
};
